import axios from 'axios';
import fileDownload from 'js-file-download';

export async function downloadAllAssets(assets = []) {
  for (const asset of assets) {
    try {
      const response = await axios.get(asset.download_url, {
        responseType: 'blob',
      });

      const filename = asset.name || 'download';
      fileDownload(new Blob([response.data]), filename);

      await new Promise(resolve => setTimeout(resolve, 200));
    } catch (error) {
      console.error('Error downloading asset:', error);
      window.Rollbar?.error('Error downloading asset', {
        error,
        message: error.message,
        stack: error.stack,
        asset,
        url,
      });
    }
  }
}
